import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-separator"></div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <h3 className="footer-brand">King's College Graduate Union</h3>
            <p className="footer-year">2025-26</p>
          </div>
          <div className="footer-right">
            <p className="footer-question">Have any questions or concerns regarding the website?</p>
            <p className="footer-contact">
              Reach out to <a href="mailto:technology@kcgu.org" className="footer-email">technology@kcgu.org</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

